import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Flex,
  FlexItem,
  Grid,
  GridCell,
  Link,
  LINK_VARIANT_EXTRALIGHT,
  LINK_VARIANT_HIGHLIGHT,
  Panel,
  SPACING_16,
  SPACING_24,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'

import { changeWizardStepCallback } from 'Pages/Campaign/recoil/callbacks/callbacks'
import {
  messageIsOnSentState,
  sendingRowData
} from 'Pages/Campaign/recoil/state/page'
import { useHistory } from 'react-router-dom'
import { campaignState } from '../../recoil/state/campaign'

const PanelGeneralInfo = () => {
  const intl = useIntl()
  const history = useHistory()
  const {
    IdSource,
    EmailOptions: { Subject, SubjectType },
    ShowNumberOfContents
  } = useRecoilValue(campaignState)
  const { sourceName, sourceType } = useRecoilValue(sendingRowData)
  const { isOnSent } = useRecoilValue(messageIsOnSentState)
  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])

  const onClickEdit = () => {
    changeWizardStep(1)
  }

  const onClickSource = () => {
    history.push(`/automation/source/${sourceType}/${IdSource}`)
  }

  return (
    <Panel>
      <Flex justifyContent='space-between'>
        <FlexItem>
          <Title variant={TITLE_VARIANT_M}>
            {intl.formatMessage({ id: 'Load.Task.Step1InfoGeneral' })}
          </Title>
        </FlexItem>
        <FlexItem>
          <Link
            variant={LINK_VARIANT_EXTRALIGHT}
            onClick={onClickEdit}
            disabled={isOnSent}
            data-mu-test='campaign-wizard__step-4__edit-step-1-button'
          >
            {intl.formatMessage({ id: 'Load.MailupCommon.Edit' })}
          </Link>
        </FlexItem>
      </Flex>
      <SpacingVertical variant={SPACING_24} />

      <Grid cols={12}>
        <GridCell span={4}>
          <Text variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({
              id: 'Load.ContentsCampaignWizard.SorgenteAssociataRecap'
            })}
          </Text>
        </GridCell>
        <GridCell span={8}>
          <Link
            variant={LINK_VARIANT_HIGHLIGHT}
            onClick={onClickSource}
            disabled={isOnSent}
          >
            ID {IdSource} - {sourceName}
          </Link>
        </GridCell>
      </Grid>
      <SpacingVertical variant={SPACING_16} />

      <Grid cols={12}>
        <GridCell span={4}>
          <Text variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({
              id: 'Load.ContentsCampaignWizard.OggettoEmail'
            })}
          </Text>
        </GridCell>
        <GridCell span={8}>
          {SubjectType === 1 && (
            <Text>
              {intl.formatMessage({
                id: 'Load.ContentsCampaignWizard.OggettoPrimoFeed'
              })}
            </Text>
          )}
          {SubjectType === 2 && (
            <Text>
              {intl.formatMessage({
                id: 'Load.ContentsCampaignWizard.OggettoPrimiTreFeed'
              })}
            </Text>
          )}
          {SubjectType === 3 && (
            <Text>
              {intl.formatMessage({
                id: 'Load.ContentsCampaignWizard.OggettoTestoFisso'
              })}
              {': '}
              {Subject}
            </Text>
          )}
        </GridCell>
      </Grid>
      <SpacingVertical variant={SPACING_16} />

      <Grid cols={12}>
        <GridCell span={4}>
          <Text variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({
              id: 'Load.ContentsCampaignWizard.CorpoMessaggioLabel'
            })}
          </Text>
        </GridCell>
        <GridCell span={8}>
          <Text>
            {intl.formatMessage(
              { id: 'Load.ContentsCampaignWizard.CorpoMessaggio' },
              { N: ShowNumberOfContents }
            )}
          </Text>
        </GridCell>
      </Grid>
    </Panel>
  )
}

export default PanelGeneralInfo
